import { SupportedChainId as ChainId } from "../constants/chains";

const rpc = {
  [ChainId.FUJI]: "https://api.avax-test.network/ext/bc/C/rpc",
  [ChainId.AVAX]: "https://api.avax.network/ext/bc/C/rpc",
  [ChainId.BSC]: "https://bsc-dataseed1.ninicoin.io/",
};

export default rpc;
